import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


// Видаткова накладна — одна на расчёт, выписывается к уже сформированному счёту.
// Поля, которые вводит пользователь (номер/дата вручную, остальное — с
// дефолтами от сервера):
export type DeliveryNoteFields = {
    number: string,
    date: string,              // YYYY-MM-DD
    basis: string,             // «Підстава», по умолчанию «Рахунок-фактура № N від …»
    contract: string,          // «Договір», по умолчанию «Основний договір»
    responsibleName: string,
    responsiblePhone: string,
    place: string,             // «Місце складання»
};

export type DeliveryNoteEntity = DeliveryNoteFields & {
    id: number,
    calculationId: number,
    pdfFile: string | null,    // путь в media/
    createdAt: string,
    updatedAt: string,
};

// GET → { note: DeliveryNoteEntity | null, defaults: DeliveryNoteFields,
//         blockedReason: string | null } — blockedReason задан, пока у расчёта
// нет сформированного счёта (сохранить накладную нельзя).
export async function deliveryNoteGetAPI(calculationId: string | number){
    try {
        return await $authHost.get(API_ENDPOINTS.DELIVERY_NOTE + `/calculation/${calculationId}`);

    } catch (error: any) {
        return error;
    }
}

// Создаёт/обновляет накладную расчёта и (пере)формирует её PDF. Возвращает сущность.
export async function deliveryNoteSaveAPI(calculationId: string | number, data: DeliveryNoteFields){
    try {
        return await $authHost.put(API_ENDPOINTS.DELIVERY_NOTE + `/calculation/${calculationId}`, data);

    } catch (error: any) {
        return error;
    }
}
